import React, { useEffect, useState } from "react";
import { CoreValuCard, CoreValuContainer } from "./styles";
import { Border } from "../../EventDetails/styles";
import { fetchApi } from "../../../utils/methods";
import { GetInactiveCoreValues } from "../../../redux/constants/apiConstants";
import LazyImage from "../../common/LazyImage/LazyImage";
import { ImageUrl } from "../../../utils/constants";
import {
  RecognitionLaunchIcon,
} from "../../../utils/icons";
import PropTypes from "prop-types";
import { ManagerIconContainer } from "../../Manager/styles";
import SkeletonLoder from "../../common/skeletonLoder";

export const InActiveLibraryTab = ({ history, companyInfo }) => {
  const [coreValues, setCoreValues] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetCompanyCoreValues(companyInfo.id);
  }, []);

  const GetCompanyCoreValues = async (companyId) => {
    setLoading(true);
    const res = await fetchApi(GetInactiveCoreValues + "/" + companyId, "GET");

    if (res.status === "success") {
      setCoreValues(res.data);
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? <SkeletonLoder width={"1246px"} height={"500px"} /> : <><CoreValuContainer>
        <div className="top-bar-container">
          <div className="header">Core Values</div>
        </div>
        <Border
          style={{
            border: "1px solid #EFEFEF",
            margin: "20px 0px",
          }}
        />

        {coreValues?.length > 0 ? <div className="core-values">
          {coreValues.map((coreValue, index) => (
            <>
              <div className="border-btm">
                <CoreValuCard
                  key={index}
                >
                  <div className="core-value-row">
                    <div className="col-one">
                      <div
                        className="icon"
                        style={{ background: coreValue?.recognition_color_value }}
                      >
                        {coreValue?.white_icon ? <LazyImage
                          style={{ width: "24px" }}
                          src={ImageUrl + "/" + coreValue?.white_icon}
                        />:null}
                      </div>
                      <div className="title">{coreValue?.core_value}</div>
                    </div>
                    <div className="action">
                      <div id="launch"
                        className="eye-icon"
                        onClick={() =>
                          history.push({
                            pathname: `/company/recognition/core-value/launch`,
                            state: {
                              title: coreValue.core_value,
                              image: coreValue?.image,
                              description: coreValue?.description,
                              points: coreValue?.point,
                              color: coreValue?.recognition_color_value,
                              status: coreValue?.active_status,
                              id: coreValue?.id,
                              type: "launch",
                              white_icon : coreValue.white_icon
                            },
                          })
                        }
                      >
                        <ManagerIconContainer>{RecognitionLaunchIcon("#F37A65")}</ManagerIconContainer>
                      </div>
                      {/* <div className="pencil-icon">{RecognitionPencilIcon()}</div> */}
                    </div>
                  </div>
                </CoreValuCard>
              </div>
            </>
          ))}
        </div>:<div className="no-data">There are No Core Values to launch</div> }
      </CoreValuContainer>
      </>}
    </>
  );
};

InActiveLibraryTab.propTypes = {
  history: PropTypes.object.isRequired,
  companyInfo: PropTypes.object.isRequired,
};
